export default "__VITE_ASSET__IKiFOOBK__"